import { State } from '@meraki-internal/state';
import { useEffect, useState } from 'react';

type IStaterGetter<TState extends State> = (...args: any[]) => Promise<TState>;

export const useSubscriptionAsync = <TState extends State>(getState: IStaterGetter<TState>): TState | undefined => {
    const [reactState, setReactState] = useState<TState | undefined>(undefined);
    const [, setCounter] = useState(1);

    useEffect(() => {
        let unsub: any;

        // Can't use async/await b/c useEffect must return nothing or an unsub function
        Promise.resolve().then(getState)
            .then((state: TState) => {
                setReactState(state);
                unsub = state.subscribe(() => {
                    // if we setReactState again, the reference hasn't changed and react will swallow it
                    setCounter(count => count+1);
                });
            });

        return () => {
            if (unsub) {
                unsub();
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return reactState;
};
